export default "__VITE_ASSET__fvabiKvt__"